import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/5 py-8 px-6 md:px-12" data-id="element-33">
      <div className="max-w-7xl mx-auto" data-id="element-34">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-35">
          <p className="font-heading text-sm tracking-widest text-ultra-purple" data-id="element-36">
            ULTRAGAMER
          </p>
          <p className="font-body text-sm text-white/30" data-id="element-37">
            © 2026 Ultragamer. All rights reserved.
          </p>
        </div>
        <p className="font-body text-xs text-white/20 text-center mt-4" data-id="element-38">
          Limassol, Cyprus
        </p>
      </div>
    </footer>;
}